<!-- <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
  <span class="icon-bar"></span>
<span class="icon-bar"></span>
<span class="icon-bar"></span>
</button>     -->
<!-- <div class="full">
    <nav class="navbar navbar-default naving" role="navigation">
        <div class="navbar-header">
    </div>
    <div class="navbar-collapse collapse">

        <ul class="nav navbar-nav navbar-left">
            <li><a><img src="https://eureka2022.s3.ap-south-1.amazonaws.com/E-logo.png" alt=""></a></li>
          </ul>
          <a class="navbar-brand" href="#">WELCOME TO EUREKA! DASHBOARD</a>
          <ul class="nav navbar-nav navbar-right">
        <li><a><img src="https://eureka2022.s3.ap-south-1.amazonaws.com/eureka-logo.png" alt=""></a></li>
      </ul>
    </div>
  </nav>
</div> -->

<div class="navnav full">
  <a href="https://ecell.in" target="_blank"
    ><img src="assets/images/logoblk.png" alt="E-CELL"
  /></a>
  <div style="align-self: center; margin-right: 20px; display: flex">
    <a class="eureka" style="cursor: pointer"
      ><img
        [routerLink]="['/']"
        src="https://2k21.s3.ap-south-1.amazonaws.com/gcc24logo.png"
        alt="EUREKA!"
    /></a>
    <a class="head1" [routerLink]="['/db']">WELCOME TO EUREKA! GCC DASHBOARD</a>
    <a class="head2" [routerLink]="['/db']">EUREKA! GCC DASHBOARD</a>
  </div>
  <div style="align-self: center; margin-right: 20px; display: flex">
    <!-- <button  type="button" class="btn btn-primary btn-lg btn-primary">Logout</button> -->
    <button
      (click)="logout()"
      routerLink="/resetpassword"
      type="button"
      class="btn inverse"
    >
      Logout
    </button>
    <!-- <button (click)="logout()" routerLink="/resetpassword"
    [queryParams]="{code: 'CfDJ8LB'}" type="button" class="btn btn-success">Logout</button> -->
  </div>
</div>
